export default function background () {
    const bc = document.querySelectorAll('[data-bg]');

    if (!bc.length) {
        return;
    }

    setTimeout(() => {
        bc.forEach(element => {
            element.style.backgroundImage = `url(${element.getAttribute('data-bg')})`;
            element.setAttribute('data-loaded', true);
        });
    }, 100);
}
